import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { getCookie } from '../utils/get-cookie';

@Injectable({
  providedIn: 'root',
})
export class FormsService {
  token: string = '';

  constructor(public httpClient: HttpClient) {
    this.token = getCookie('token');
  }

  getForm(studyId: number) {
    return this.httpClient.get(
      `${environment.api_guia}studies/${studyId}/forms`,
      {
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  }

  createForms(studyId: number) {
    return this.httpClient.post(
      `${environment.api_guia}forms/${studyId}`,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  }
}
